var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.user?.role?.id == 6)?_c('v-container',[_c('p',[_vm._v("Processos em alerta")])]):_c('v-container',[_c('p',[_vm._v("Acesso não autorizado")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }